import chroma from 'chroma-js'
import * as _ from 'lodash'
import { addSeconds, isBefore } from "date-fns";


import * as React from 'react'
import Select from 'react-select';
import { StylesConfig } from 'react-select/lib/styles';
import { getCommentCodes, ICommentCodeIndex } from './http';

interface ICommentCodeSelectProps {
  values: Array<string | null>
  onChange?: (newValues: Array<string | null>) => void
  onClose?: (newCodes: Array<string | null>) => void
  disabled?: boolean
}

interface ICommentCodeSelectState {
  codes: ICommentCodeIndex[]
  selectedMood: string;
  groupOptions: ICommentCodeGroupOption[]
}

export interface ICommentCodeOptionType extends ICommentCodeIndex {
  label: string;
  value: string;
}

export interface ICommentCodeGroupOption {
  label: string;
  options: ICommentCodeOptionType[];
}

export class CommentCodeSelect extends React.Component<ICommentCodeSelectProps, ICommentCodeSelectState> {
  public static readonly MoodColors = {
    suggestion: '#ffaa00',
    neutral: '#e7e7e7',
    compliment: '#0493FC',
    none: '#FFF'
  }
  private static CachedCodes: Promise<ICommentCodeIndex[]> = null
  private static CachedCodesTTL: Date | null = null;
  private static LoadCodes() {
    const now = new Date();
    const isTimeToDie = CommentCodeSelect.CachedCodesTTL && isBefore(CommentCodeSelect.CachedCodesTTL, now);
    if (isTimeToDie) {
      CommentCodeSelect.CachedCodes = null
      CommentCodeSelect.CachedCodesTTL = null
    }

    if (!CommentCodeSelect.CachedCodes) {
      CommentCodeSelect.CachedCodesTTL = addSeconds(now, 30);
      CommentCodeSelect.CachedCodes = getCommentCodes(true, false)
    }
    return CommentCodeSelect.CachedCodes
  }

  state: ICommentCodeSelectState = {
    codes: [],
    selectedMood: '',
    groupOptions: []
  }

  componentWillMount() {
    CommentCodeSelect.LoadCodes().then((codes) => {
      const selectedMood = _.map(codes, 'mood').sort()[0];
      const groupOptions = this.getGroupOptions(codes);

      this.setState({ codes, selectedMood, groupOptions })
    })
  }

  codeIndexToSelectOption(codeIndex: ICommentCodeIndex): ICommentCodeOptionType {
    return {
      label: codeIndex.shortLabel,
      value: codeIndex.shortLabel,
      ...codeIndex
    }
  }

  getGroupOptions(codes: ICommentCodeIndex[]): ICommentCodeGroupOption[] {
    const codesGroupedByMood = _.groupBy(codes, 'mood')

    const groupedOptions = Object.keys(codesGroupedByMood).map((mood) => {
      const options = codesGroupedByMood[mood].map((codeIndex) => this.codeIndexToSelectOption(codeIndex))

      return { label: mood, options }
    })

    return groupedOptions;
  }

  getMoodColor(codeIndex: ICommentCodeIndex) {
    if ('mood' in codeIndex) {
      const moodLower = codeIndex.mood.toLowerCase()
      return CommentCodeSelect.MoodColors[moodLower]
    }

    return CommentCodeSelect.MoodColors.none;
  }

  getColorStyles() {
    const colorStyles: StylesConfig = {
      control: (styles) => ({ ...styles, backgroundColor: 'white' }),
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        const commentOption = data as ICommentCodeOptionType;
        const color = this.getMoodColor(commentOption);

        return { ...styles, color }
      },
      multiValue: (styles, { data }) => {
        const commentOption = data as ICommentCodeOptionType;
        const moodColor = this.getMoodColor(commentOption);
        const backgroundColor = chroma(moodColor).css();
        let border: string;

        if (moodColor === CommentCodeSelect.MoodColors.none) {
          border = '1px solid #999';
        }

        return { ...styles, backgroundColor, border };
      },
      multiValueLabel: (styles, { data }) => {
        const commentOption = data as ICommentCodeOptionType;
        const moodColor = this.getMoodColor(commentOption);
        const color = chroma(moodColor).darken(4).css();

        return { ...styles, color }
      },
      groupHeading: (styles, { children }) => {
        let color: string;
        const fontSize = '1.2rem'

        if (typeof children === 'string') {
          const mood = children.toLowerCase()
          const moodColor = CommentCodeSelect.MoodColors[mood];
          color = chroma(moodColor).css();
        }

        return { ...styles, color, fontSize }
      }
    }

    return colorStyles
  }

  render() {
    const { onChange = () => ({}) } = this.props;
    const { groupOptions } = this.state;
    const checkedCodes = this.props.values
      .filter((v) => v !== null)
      .map((shortLabel) => {
        let valueOption: ICommentCodeOptionType;

        groupOptions.every((groupOption) => {
          const possibleValueOption = groupOption.options.find((o) => o.shortLabel === shortLabel)

          if (possibleValueOption) {
            valueOption = possibleValueOption;
            return false;
          }

          return true;
        })

        return valueOption;
      })

    return (
      <Select isMulti
        className="react-select-container"
        classNamePrefix="react-select"
        isDisabled={this.props.disabled}
        styles={this.getColorStyles()}
        options={groupOptions}
        value={checkedCodes}
        onChange={(newValueOptions: ICommentCodeOptionType[]) => {
          let newValues = newValueOptions.map((newValue) => newValue.shortLabel)
          const limit = 6;
          newValues = _.take(newValues, limit);

          onChange(newValues)
        }}
      />
    )
  }
}
